export default __webpack_public_path__ + "static/media/Royals.0aa8cdf0.png";